module.exports = __webpack_public_path__ + "img/3.06.9db0ab5a.jpg";